import { SxProps } from '@mui/material'
import { FONT_WEIGHTS } from '@/styles'
import { dropdownButtonClasses } from './DropdownButton.data'

interface DropdownButtonStyles {
  button: SxProps
  label: SxProps
  labelHeading: SxProps
  iconWrapper: SxProps
}

export const dropdownButtonStyles: DropdownButtonStyles = {
  button: {
    px: 1.5,
    py: 1,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'border.primary',
    borderRadius: 2,
    outlineWidth: 1,
    outlineStyle: 'solid',
    outlineColor: 'transparent',
    transition: 'all .3s',
    textAlign: 'left',

    [`&.${dropdownButtonClasses.active}`]: {
      borderColor: 'border.brand',
      outlineColor: 'border.brand',
    },
    [`&.${dropdownButtonClasses.withHeading}`]: {
      py: 0.25,
    },
    [`&.${dropdownButtonClasses.fullWidth}`]: {
      width: '100%',
    },
    [`&.${dropdownButtonClasses.fullWidthWithSpace}`]: {
      width: 'calc(100% - 2px)', // 2px is the width of outline
      ml: '1px', // to align with the parent container,
    },
  },
  label: {
    typography: 'textMd',
    color: 'text.primary900',
    whiteSpace: 'nowrap',

    [`.${dropdownButtonClasses.withHeading} &`]: {
      lineHeight: '20px',
      transform: 'translateY(-2px)',
    },
  },
  labelHeading: {
    typography: 'textXs',
    fontSize: '10px',
    fontWeight: FONT_WEIGHTS.STRONG,
    color: 'text.secondary700',
  },
  iconWrapper: {
    color: 'foreground.quaternary500',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all .15s',
    pt: 0.25,

    [`.${dropdownButtonClasses.active} &`]: {
      transform: 'rotate(-180deg)',
    },

    [`.${dropdownButtonClasses.icon}`]: {
      width: 20,
    },
  },
}
